var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16329 0.362212C7.90381 -0.120737 7.09685 -0.120737 6.83736 0.362212L0.087697 12.9159C0.0269377 13.0285 -0.00318414 13.1546 0.000266379 13.282C0.0037169 13.4093 0.0406221 13.5337 0.107386 13.6428C0.17415 13.752 0.268496 13.8423 0.38123 13.9049C0.493965 13.9675 0.621243 14.0002 0.750664 14H14.25C14.3793 14.0003 14.5065 13.9675 14.6192 13.905C14.7318 13.8424 14.8261 13.7522 14.8928 13.6431C14.9595 13.534 14.9963 13.4097 14.9997 13.2824C15.0031 13.1551 14.973 13.0291 14.9122 12.9167L8.16329 0.362212ZM8.25029 11.7846H6.75036V10.3077H8.25029V11.7846ZM6.75036 8.83081V5.13854H8.25029L8.25104 8.83081H6.75036Z",
    fill: "#ED6265"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.fabeb31abaa3944e86d9c8c26da77fe2.svg";
export { ForwardRef as ReactComponent };